module.exports = __webpack_public_path__ + "static/media/exc_haz_lev.31f0c86b.png";